import Container from "shared/components/Container";
import graphql from "utils/api/graphql";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { CHAIN_TYPES, SCREENS } from "utils/constants";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { useState } from "react";
import { Button } from "antd";
import { isNil } from "lodash";

const Convert = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const CONVERT = t("CONVERT", { returnObjects: true });
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [executeFlow] = useMutation(graphql.mutations.EXECUTE_FLOW, {
    onCompleted: () => navigate(SCREENS.PRIVATE.XO.ACCOUNTS.LIST.path),
    onError: () => {},
  });

  return (
    <Container>
      <div className="field--item">
        <Input
          onChange={(e) =>
            setData((data) => ({
              ...data,
              amount: e.target.value,
            }))
          }
          placeholder={CONVERT.FORM.FIELDS.AMOUNT}
        />
      </div>
      <div className="field--item">
        <Select
          onSelet={(item) => {
            setData((data) => ({
              ...data,
              currencies: { ...data.currencies, from: item.type },
            }));
          }}
          type="async"
          node={[
            graphql.queries.TOKENS,
            {
              variables: {
                where: {
                  chain: CHAIN_TYPES.CRYPTO,
                },
              },
            },
            "tokens.data",
          ]}
          placeholder={CONVERT.FORM.FIELDS.FROM_CURRENCY}
          format={(token) => token.type}
        />
      </div>
      <div className="field--item">
        <Select
          onSelet={(item) => {
            setData((data) => ({
              ...data,
              currencies: { ...data.currencies, to: item.type },
            }));
          }}
          type="async"
          node={[
            graphql.queries.TOKENS,
            {
              variables: {
                where: {
                  chain: CHAIN_TYPES.CRYPTO,
                },
              },
            },
            "tokens.data",
          ]}
          placeholder={CONVERT.FORM.FIELDS.TO_CURRENCY}
          format={(token) => token.type}
        />
      </div>
      <div className="field--item">
        <Button
          disabled={
            isNil(data.amount) ||
            isNil(data.currencies?.from) ||
            isNil(data.currencies?.to)
          }
          onClick={() => {
            return executeFlow({
              variables: {
                where: {},
                data: {
                  state: "swap",
                  currencies: data.currencies,
                  amount: data.amount,
                  product: {
                    id: "1",
                  },
                },
              },
            });
          }}
        >
          {CONVERT.FORM.ACTIONS.CONVERT}
        </Button>
      </div>
    </Container>
  );
};

export default Convert;
